export const containerIndent = 32;
export const containerItemHeight = 30;
export const containerMaxHeight = 190;
export const containerGap = 10;

export const maxInputValue = 1_000_000;
